import React, { useState, useMemo, useRef } from "react";
import { Button, Modal, Input as AntInput, Form } from "antd";
import { FormWrapperInputComponent } from "../../../../common/component/Index";
import { useTranslation } from "react-i18next";
import DEFINE, {
  UPLOAD_DIRECTORY
} from "../../../../../../constants/Define";
import UploadImage from "../../../../common/component/UploadImage";
import ApiService from '../../../../../../api/ApiService';
import Urls from '../../../../../../api/Urls';
import Config from '../../../../../../constants/Config';
import UploadResponse from '../../../../../../models/UploadResponse';

const UPLOAD_FILE_TYPE = {
  AVATAR: "AVATAR",
  COVER: "COVER"
};

function UnionBankCreateFormSection (props) {
  const { t } = useTranslation();
  const { setReloadBankList } = props;

  // Modal
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    clearUnionBankInput();
    setIsModalOpen(true);
  };
  const handleOk = () => {
    unionBankSubmit();
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };
  const unionBankSubmit = () => {
    let name = unionBankName.current.state.value?? "";
    let img = unionBankImg.current.props?.thumbnails ? unionBankImg.current.props.thumbnails[0] : "";
    if(name && img) {
      let unionBankData = {
        title: name,
        logo: img,
      };
      new ApiService({
        baseURL: Config.API_PROMOTION,
        endpoint: Urls.CREATE_UNION_BANK,
      }).post(unionBankData).then((response) => {
        if(!response.errors && response.success) {
          setIsModalOpen(false);

          // Force update
          setReloadBankList(true);
          setReloadBankList(false);
        }
      });
    }
  };
  const clearUnionBankInput = () => {
    let name = unionBankName.current?.state.value?? "";
    let img = unionBankImg.current?.props?.thumbnails ? unionBankImg.current.props.thumbnails[0] : "";
    if(name) {
      unionBankName.current.state.value = "";
    }
    if(img) {
      setAvatarFile("");
    }
  }
  const [avatarFile, setAvatarFile] = useState();
  const unionBankName = useRef();
  const unionBankImg = useRef();
  const getSrc = file => {
    const src = file?.fileUri ?? file?.fileUrl;
    if (src && src.startsWith(DEFINE.GENERAL.CDN_IMG_DEFAULT)) {
      return [src];
    }
    return src ? [`${DEFINE.GENERAL.CDN_IMG_DEFAULT}${src}`] : null;
  };

  const avatarThumb = useMemo(() => {
    return getSrc(avatarFile);
  }, [avatarFile]);

  const uploadFile = (file, type) => {
    let _type = file.target.files[0].type;
    if(_type.indexOf('video') === -1) {
      let data = new FormData();
      data.append('file', file.target.files[0]);
      data.append('directory', 'bank_logos');
      new ApiService({
        baseURL: Config.API_CMS,
        endpoint: Urls.UPLOAD_STORAGE,
        parser: data => new UploadResponse(data.data),
      }).post(data).then((res) => {
        setAvatarFile(res);
      });
    }
  };

  const onRemoveAvatar = () => {
    setAvatarFile();
  };
  // End Modal

  return (
    <div className="create-bank-wrapper">
      <Button type="primary" onClick={showModal}>Tạo ngân hàng</Button>
      <Modal title="Tạo ngân hàng" visible={isModalOpen} okText="Tạo" wrapClassName="create-bank" onOk={handleOk} onCancel={handleCancel}>
        <FormWrapperInputComponent
          isRequired={true}
          labelTitle={t(`item.app.title`)}
        >
          <AntInput placeholder={t(`item.app.title`)} ref={unionBankName} />
        </FormWrapperInputComponent>
        <FormWrapperInputComponent
          isRequired={true}
          typeInput={true}
          classLabel="col-md-12"
          classInputForm="col-md-12"
          labelTitle={t(
            `item.campaign.campaignPromotionInfoSection.avatar`
          )}
          className="mb-0"
        >
          <UploadImage
            multiple={false}
            isPreview3x3={true}
            thumbnailSize={"150px"}
            buttonSize={120}
            thumbnailStyle={{ maxHeight: 120 }}
            uploadText={t("item.tour.uploadFile")}
            loadingText={t("item.tour.uploading")}
            onChange={file => uploadFile(file, UPLOAD_FILE_TYPE.AVATAR)}
            onRemoveThumbnail={onRemoveAvatar}
            thumbnails={avatarThumb}
            ref={unionBankImg}
          />
        </FormWrapperInputComponent>
      </Modal>
    </div>
  );
}

export default UnionBankCreateFormSection;
